<template>
  <v-card class="mx-auto" max-width="460" rounded="lg" elevation="6">
    <v-toolbar dense tile flat color="grey lighten-3">
      <v-toolbar-title class="align-center d-flex text-subtitle-1">
        <v-icon left>mdi-login-variant</v-icon>
        {{ title }}
      </v-toolbar-title>
      <v-progress-linear
        :active="inProcess"
        absolute
        bottom
        height="4"
        indeterminate
      />
    </v-toolbar>

    <v-img
      src="/assets/SDLOGO_STACKED.png"
      max-width="190"
      class="mx-auto mt-6 mb-2"
    />

    <ValidationObserver ref="validator" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(submit)">
        <v-card-text class="input-fields">
          <AlertsAnimated />
          <slot></slot>
        </v-card-text>
        <v-divider />
        <v-card-actions class="pa-4">
          <v-spacer />
          <v-btn v-if="showCancel" :disabled="inProcess" text @click="cancel">
            Cancel
          </v-btn>
          <v-btn color="primary" depressed :disabled="inProcess" type="submit">
            {{ submitText }}
          </v-btn>
        </v-card-actions>
      </form>
    </ValidationObserver>
  </v-card>
</template>

<script>
import AlertsAnimated from "@tod-ui/components/AlertsAnimated.vue";
import { setInteractionMode, ValidationObserver } from "vee-validate";

setInteractionMode("lazy");

export default {
  name: "FormLayoutAuthentication",
  components: { ValidationObserver, AlertsAnimated },
  props: {
    title: {
      type: String,
      required: true,
    },
    submitText: {
      type: String,
      required: true,
    },
    inProcess: {
      type: Boolean,
      default: false,
    },
    showCancel: {
      type: Boolean,
      default: true,
    },
  },
  beforeUpdate() {
    this.$refs.validator.reset();
  },
  methods: {
    submit() {
      this.$emit("submit");
    },
    cancel() {
      this.$emit("cancel");
    },
  },
};
</script>

<style scoped>
/* A modest floor keeps the card from feeling cramped without leaving a large
   empty gap above the actions on short forms (e.g. password reset). */
.input-fields {
  min-height: 7em;
}
</style>
